// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ValidationErrorMessage__errorMessage___yDsH6{color:var(--pink);margin-left:1em;text-wrap:pretty}", "",{"version":3,"sources":["webpack://./src/shared/components/formInputs/ValidationErrorMessage.scss"],"names":[],"mappings":"AAAA,8CACE,iBAAA,CACA,eAAA,CACA,gBAAA","sourcesContent":[".errorMessage {\n  color: var(--pink);\n  margin-left: 1em;\n  text-wrap: pretty;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": "ValidationErrorMessage__errorMessage___yDsH6"
};
export default ___CSS_LOADER_EXPORT___;
